/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';
import { css } from '@emotion/react';

interface IProps {
  children?: React.ReactNode;
  design: {
    // shape
    left?: string;
    right?: string;
    height?: string; // e.g: 10px
    padding?: string; // e.g: 10px 10px 10px 10px
    margin?: string; // e.g: 10px 10px 10px 10px

    // align
    align?: 'left' | 'center' | 'right' | 'between' | 'around';

    // background
    backgroundColor?: string;
    boxShadow?: string;
    zIndex?: number;
  };
}

const Wrapper = styled.div<Pick<IProps, 'design'>>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  position: fixed;
  top: var(--sat);
  z-index: ${(props) => props.design.zIndex || 'auto'};
  left: ${(props) => props.design.left || '0px'};
  right: ${(props) => props.design.right || '0px'};
  height: ${(props) => props.design.height || 'auto'};
  padding: ${(props) => props.design.padding || '0px'};
  margin: ${(props) => props.design.margin || '0px'};
  background-color: ${(props) => props.design.backgroundColor || 'transparent'};
  box-shadow: ${(props) => props.design.boxShadow || 'none'};

  &::before {
    content: '';
    position: absolute;
    top: calc(-1 * var(--sat));
    left: 0;
    right: 0;
    height: var(--sat);
    background-color: inherit;
  }

  ${(props) =>
    props.design.align &&
    css`
      justify-content: ${props.design.align === 'left'
        ? 'flex-start'
        : props.design.align === 'right'
          ? 'flex-end'
          : props.design.align === 'between'
            ? 'space-between'
            : props.design.align === 'around'
              ? 'space-around'
              : 'center'};
    `}
`;

const HeaderContainer: React.FC<IProps> = ({ children, design }) => {
  return <Wrapper design={design}>{children}</Wrapper>;
};

export default HeaderContainer;
